<template>
  <div
    v-if="config.crudMode"
    class="modal fade"
    id="dashboardEditContentModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="dashboardEditContentModalLabel"
    aria-hidden="true"
  >
    <div :class="modalClass" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="dashboardEditContentModalLabel" v-if="config">
            {{ headerTitle }}
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group row" v-for="(value, index) in locales" :value="value" :key="index">
            <label for="inputChartDataValue" class="col-sm-3 col-form-label"
              >{{ $t('modal.title') }} - {{ value.toUpperCase() }}</label
            >
            <div class="col-sm-9">
              <input
                type="title"
                :maxlength="maxCharacters"
                class="form-control form-control-sm"
                id="inputTabTitle"
                :placeholder="$t('modal.title')"
                v-model="config.titles[value]"
              />
            </div>
          </div>
          <div v-if="config.crudMode == 'duplicate'">
            <div
              class="form-group align-items-center row"
              v-for="(filter, index) in presetFilters"
              :key="index"
            >
              <label :for="'input' + filter.type" class="col-sm-4 col-form-label">{{
                $t('filter.' + filter.type)
              }}</label>
              <div class="col-sm-6">
                <select
                  class="custom-select"
                  v-model="filter.values"
                  :id="'input' + filter.type"
                  multiple
                >
                  <option
                    v-for="value in configFilterHierarchy.filter_values[filter.type]"
                    :key="value"
                    :value="value"
                  >
                    <span>{{ getFilterValueLabel(filter.type, value) }}</span>
                  </option>
                </select>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="btn btn-danger m-2 mr-sm-2"
                  @click="deleteFilter(index)"
                >
                  <i class="fas fa-trash-alt"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- Add filters -->
          <div class="form-group row border-top" v-if="config.crudMode == 'duplicate'">
            <div class="form-inline col-sm-12" v-for="(filter, index) in newFilters" :key="index">
              <select class="form-control m-2 mr-sm-2 col" v-model="inputFilters[index]">
                <option v-for="value in availableFilters" :value="value" :key="value">
                  {{ $t('filter.' + value) }}
                </option>
              </select>
              <select
                class="form-control m-2 mr-sm-2 col"
                v-model="inputFiltersValues[index]"
                multiple
              >
                <option
                  v-for="value in allowedFilterValues[inputFilters[index]]"
                  :key="value"
                  :value="value"
                >
                  <span>{{ getFilterValueLabel(inputFilters[index], value) }}</span>
                </option>
              </select>
              <button type="button" class="btn btn-danger m-2 mr-sm-2" @click="deleteRow(index)">
                <i class="fas fa-trash-alt"></i>
              </button>
              <button
                v-if="inputFiltersValues[index].length > 0"
                type="button"
                class="btn btn-success m-2 mr-sm-2"
                @click="validateRow(index)"
              >
                <i class="fas fa-check"></i>
              </button>
              <button
                v-if="inputFiltersValues[index].length == 0"
                type="button"
                class="btn btn-success m-2 mr-sm-2 disabled"
                v-tooltip="{ content: $t('filter.add_invalid'), placement: 'top-center' }"
              >
                <i class="fas fa-check"></i>
              </button>
            </div>
          </div>

          <div
            v-if="config.crudMode == 'duplicate'"
            class="form-group row justify-content-md-center"
          >
            <button
              v-if="newFilters.length == 0"
              type="button"
              class="btn btn-light m-2 col-sm-4"
              @click="addRowFilter"
            >
              <i class="fas fa-plus"></i>
              {{ $t('preconfig') }}
            </button>
            <button
              v-if="newFilters.length > 0"
              type="button"
              class="btn btn-light m-2 col-sm-4 disabled"
              v-tooltip="{ content: $t('filter.select_invalid'), placement: 'top-center' }"
            >
              <i class="fas fa-plus"></i>
              {{ $t('preconfig') }}
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            {{ $t('cancel') }}
          </button>
          <button
            v-if="onConfirmValidateModal"
            type="button"
            class="btn btn-primary"
            data-dismiss="modal"
            @click="$emit('onConfirmModal', config, presetFilters)"
          >
            {{ $t('confirm') }}
          </button>
          <button
            v-if="!onConfirmValidateModal"
            type="button"
            class="btn btn-primary disabled"
            v-tooltip="{ content: errorTooltip, placement: 'top-center' }"
          >
            {{ $t('confirm') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { utilsMixin, sitesMixin } from '../../utils/mixins'

export default {
  name: 'DashboardEditModal',
  mixins: [utilsMixin, sitesMixin],
  props: ['config'],
  data() {
    return {
      editConfig: null,
      presetFilters: [],
      newFilters: [],
      inputFilters: [],
      inputFiltersValues: [],
      errorTooltip: '',
      configFilters: null,
      maxCharacters: 36,
    }
  },
  mounted() {
    this.configFilters = JSON.parse(JSON.stringify(this.configFilterHierarchy))
  },
  watch: {
    config: {
      handler: function() {
        if (this.config.crudMode == 'duplicate') {
          for (let key in this.config.titles) {
            this.config.titles[key] =
              this.config.titles[key] + ' - ' + this.$i18n.messages[key]['copy']
          }
          this.presetFilters = []
        }
      },
      immediate: true,
    },
    onConfirmValidateModal: {
      deep: true,
      handler: val => {
        if (!val) {
          this.errorTooltip =
            this.$t('sidebar.title_invalid') +
            ' ' +
            this.$t('and') +
            ' ' +
            this.$t('sidebar.filters_invalid')
        }
      },
    },
  },
  computed: {
    modalClass: function() {
      if (this.config.crudMode == 'duplicate') {
        return 'modal-dialog modal-lg'
      } else {
        return 'modal-dialog'
      }
    },
    onConfirmValidateModal: function() {
      let titles = ''
      for (let key in this.config.titles) {
        titles += this.config.titles[key].trim()
      }

      if (!this.config.crudMode == 'duplicate') {
        return titles !== ''
      } else {
        return titles !== '' && this.newFilters.length == 0
      }
    },
    headerTitle: function() {
      let headerTitle =
        this.config.crudMode == 'duplicate'
          ? this.$t(this.config.model + '.' + this.config.crudMode, [
              this.config.titles[this.$locale],
            ])
          : this.$t(this.config.model + '.' + this.config.crudMode)

      return headerTitle
    },
    availableFilters: function() {
      let availableFilters = this.configFilters.filters.filter(f => {
        let selectedFilter = this.presetFilters.find(cf => {
          return cf.type == f
        })
        if (selectedFilter) {
          return false
        } else {
          return true
        }
      })

      availableFilters = availableFilters.filter(filter => {
        return filter !== 'site_id'
      })

      return availableFilters
    },
    allowedFilterValues: function() {
      let filterValues = JSON.parse(JSON.stringify(this.configFilters.filter_values))

      if (this.presetFilters.length > 0 || this.inputFilters.length > 0) {
        let configFiltersTemp = { filter_values: {} }

        //Filter allowed values if a site_id filter has been set yet (i.e: update the available total of collected treasures count according to the site_id previously set)
        let siteIDFilter = this.presetFilters.find(f => {
          return f.type == 'site_location' || f.type === 'site_id'
        })

        if (siteIDFilter) {
          siteIDFilter.values.forEach(siteID => {
            for (let key in this.configFilters.custom[siteID]) {
              if (!configFiltersTemp.filter_values[key]) {
                configFiltersTemp.filter_values[key] = this.configFilters.custom[siteID][key]
              } else {
                configFiltersTemp.filter_values[key] = configFiltersTemp.filter_values[key].concat(
                  this.configFilters.custom[siteID][key].filter(f => {
                    return configFiltersTemp.filter_values[key].indexOf(f) < 0
                  }),
                )
              }
            }
          })

          for (let key in filterValues) {
            if (configFiltersTemp.filter_values[key]) {
              filterValues[key] = configFiltersTemp.filter_values[key]
            }
          }
        }
      }

      return filterValues
    },
  },
  methods: {
    addRowFilter: function() {
      this.newFilters.push({})
      this.inputFilters.push(this.availableFilters[0])
      this.inputFiltersValues.push([])
    },
    deleteFilter(index) {
      this.presetFilters.splice(index, 1)
    },
    deleteRow(index) {
      this.newFilters.splice(index, 1)
      this.inputFilters.splice(index, 1)
      this.inputFiltersValues.splice(index, 1)
    },
    validateRow(index) {
      this.presetFilters.push({
        type: this.inputFilters[index],
        values: this.inputFiltersValues[index],
      })
      this.deleteRow(index)
    },

    getFilterValueLabel(filterType, value) {
      switch (filterType) {
        case 'site_location':
          return this.getLocalizedSiteName(value)
        case 'site_id':
        case 'language':
        case 'product':
        case 'warning_type':
          return this.$t(filterType + '.' + value)
        case 'site':
          return this.$i18n.messages[this.$locale][filterType][value]
        default:
          return value
      }
    },
  },
}
</script>
